import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {ReviewsModerationTab} from './ReviewsModerationTab'
import {ExternalReviewsConfigTab} from './ExternalReviewsConfigTab'
import {fetchPendingReviewsCount} from './reviewsManagementApi'

const PENDING_QK = ['tour-reviews-pending-count']

const ReviewsManagementPage: React.FC = () => {
  const intl = useIntl()
  const [activeTab, setActiveTab] = useState<'reviews' | 'config'>('reviews')

  const {data: pendingCount = 0} = useQuery(PENDING_QK, fetchPendingReviewsCount, {
    refetchInterval: 120_000,
    refetchOnWindowFocus: true,
  })

  return (
    <>
      {/* Page Header */}
      <section
        className='mb-8 d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-end gap-3'
      >
        <div>
          <h2
            className='font-headline font-extrabold tracking-tight mb-1'
            style={{fontSize: '1.75rem', color: '#00347f', fontFamily: 'Manrope, sans-serif', margin: 0}}
          >
            {intl.formatMessage({id: 'REVIEWS.PAGE_TITLE'})}
          </h2>
          <p style={{color: '#434652', margin: '0.25rem 0 0', fontSize: '1rem'}}>
            {intl.formatMessage({id: 'REVIEWS.BREADCRUMB'})}
          </p>
        </div>
        <div className='d-flex flex-wrap gap-2'>
          <button
            className='flex items-center gap-2'
            style={{
              padding: '0.625rem 1.25rem',
              backgroundColor: 'white',
              color: '#00347f',
              border: '1px solid rgba(195, 198, 212, 0.3)',
              borderRadius: '0.75rem',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            <span className='material-symbols-outlined' style={{fontSize: '18px'}}>download</span>
            Export CSV
          </button>
          <button
            style={{
              padding: '0.625rem 1.25rem',
              background: 'linear-gradient(135deg, #00347f 0%, #1a4ba1 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '0.75rem',
              fontSize: '0.875rem',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            <span className='material-symbols-outlined' style={{fontSize: '18px'}}>refresh</span>
            Refresh Feed
          </button>
        </div>
      </section>

      {/* Tabs */}
      <div style={{display: 'flex', gap: '0', marginBottom: '1.5rem', borderBottom: '1px solid #eceef0'}}>
        <button
          onClick={() => setActiveTab('reviews')}
          style={{
            padding: '0.75rem 1.5rem',
            background: 'none',
            border: 'none',
            borderBottom: activeTab === 'reviews' ? '2px solid #00347f' : '2px solid transparent',
            color: activeTab === 'reviews' ? '#00347f' : '#434652',
            fontWeight: activeTab === 'reviews' ? 700 : 500,
            fontSize: '0.9rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          {intl.formatMessage({id: 'REVIEWS.TAB.REVIEWS'})}
          {pendingCount > 0 && (
            <span
              style={{
                minWidth: '18px',
                height: '18px',
                padding: '0 4px',
                borderRadius: '9999px',
                backgroundColor: '#ba1a1a',
                color: 'white',
                fontSize: '10px',
                fontWeight: 700,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {pendingCount > 99 ? '99+' : pendingCount}
            </span>
          )}
        </button>
        <button
          onClick={() => setActiveTab('config')}
          style={{
            padding: '0.75rem 1.5rem',
            background: 'none',
            border: 'none',
            borderBottom: activeTab === 'config' ? '2px solid #00347f' : '2px solid transparent',
            color: activeTab === 'config' ? '#00347f' : '#434652',
            fontWeight: activeTab === 'config' ? 700 : 500,
            fontSize: '0.9rem',
            cursor: 'pointer',
          }}
        >
          {intl.formatMessage({id: 'REVIEWS.TAB.CONFIG'})}
        </button>
      </div>

      {activeTab === 'reviews' ? <ReviewsModerationTab /> : <ExternalReviewsConfigTab />}
    </>
  )
}

export default ReviewsManagementPage
